/* eslint-disable import-x/no-default-export */
import Chance from 'chance';

import { mapCountryName } from './RightToWork';
const chance = new Chance();

type SalaryType = 'annually' | 'hourly';

const getCountryId = () => chance.pickone([3000, 3001, 3002]);

const mapSalaryRange = (
  preferNotToSay: boolean,
  type: SalaryType | null,
  countryId?: number,
) => {
  let salaryRange;
  if (!preferNotToSay) {
    if (countryId === 3000 || countryId === 3001) {
      salaryRange =
        type === 'hourly'
          ? chance.pickone([15, 20, 25, 30, 35, 40, 50, 60, 75, 100])
          : chance.pickone([
              30000, 35000, 40000, 45000, 50000, 55000, 60000, 65000, 70000,
              80000, 90000, 100000, 110000, 120000, 130000, 140000, 150000,
              170000, 200000, 300000, 350000,
            ]);
    } else {
      salaryRange =
        type === 'hourly'
          ? chance.pickone([5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65])
          : chance.pickone([
              5000, 10000, 15000, 20000, 25000, 30000, 35000, 40000, 45000,
              50000, 60000, 70000, 80000, 90000, 100000, 110000, 120000, 130000,
              140000, 150000, 160000, 170000, 180000, 190000, 200000,
            ]);
    }
    return salaryRange;
  }
  return null;
};

const mapSalaryType = (preferNotToSay: boolean): SalaryType | null =>
  !preferNotToSay ? chance.pickone(['annually', 'hourly']) : null;

export default () => {
  const id = chance.guid();
  const preferNotToSay = chance.bool({ likelihood: 30 });
  const countryId = getCountryId();
  const showSalaryData = preferNotToSay === false;
  const type = mapSalaryType(preferNotToSay);
  return {
    id,
    taxonomyCountry: {
      id: countryId,
      description: () => mapCountryName(countryId),
    },
    preferNotToSay,
    ...(showSalaryData
      ? {
          type,
          range: {
            minimum: mapSalaryRange(preferNotToSay, type),
          },
        }
      : {}),
  };
};
